<template>
  <div class="bg-primary-950 rounded-2xl flex flex-col sm:flex-row items-center gap-6 px-8 py-6">
    <div class="shrink-0 relative size-12">
      <TIcon
        :icon="['fal', 'rv']"
        size="3xl"
        class="text-white absolute top-0 left-0 right-0 bottom-0 m-auto inset-0 animate-icon-fade-in-out"
      />
      <TIcon
        :icon="['fal', 'caravan']"
        size="3xl"
        class="text-white absolute top-0 left-0 right-0 bottom-0 m-auto inset-0 animate-icon-fade-in-out-reverse"
      />
    </div>

    <div class="flex-1 text-center sm:text-left">
      <p class="font-semibold text-lg text-white">
        {{ hostAdTitle }}
      </p>
      <p class="text-white/80">
        {{ t('hostAd.subtitle') }}
      </p>
    </div>

    <TButton
      :to="linkListRv"
      variant="highlight"
      class="shrink-0"
      @click="handleHostAdClick"
    >
      {{ t('hostAd.cta') }}
    </TButton>
  </div>
</template>

<script setup lang="ts">
import type { COUNTRY_SHORTS } from '~/constants'

const props = defineProps<{
  maxRvEarnings?: number
  countryCode: COUNTRY_SHORTS
}>()

const { t } = useI18n()
const { priceDisplay } = usePrice()
const { linkListRv } = useOwnerCommon()

const hostAdEarningsDisplay = computed(() => {
  if (!props.maxRvEarnings || Number.isNaN(props.maxRvEarnings)) {
    return ''
  }

  return priceDisplay({ value: props.maxRvEarnings, countryCode: props.countryCode, round: true })
})

const hostAdTitle = computed(() => {
  const amount = hostAdEarningsDisplay.value

  return amount
    ? t('hostAd.title', { amount })
    : t('hostAd.titleFallback')
})

const { pageSource } = usePageSource()
function handleHostAdClick() {
  trackCTAClicked({
    cta: t('hostAd.cta'),
    pageSource: pageSource.value,
  })
}
</script>

<i18n lang="json">
{
  "en": {
    "hostAd": {
      "title": "Own an RV? Earn up to {amount}/year.",
      "titleFallback": "Own an RV? Earn extra income on RVezy.",
      "subtitle": "List your motorhome or travel trailer for free on RVezy.",
      "cta": "List your RV"
    }
  },
  "fr": {
    "hostAd": {
      "title": "Vous avez un VR? Gagnez jusqu'à {amount}/an.",
      "titleFallback": "Vous avez un VR? Gagnez des revenus supplémentaires sur RVezy.",
      "subtitle": "Inscrivez votre motorisé ou roulotte gratuitement sur RVezy.",
      "cta": "Inscrivez votre VR"
    }
  }
}
</i18n>
